import { setLocalStorage, getLocalStorage, removeLocalStorage } from '@/utils'
import { USER_TOKEN, USER_INFO, USER_BALANCE_INFO, USER_ONLINE_BALANCE_INFO, EDIT_ADDRESS, USER_PHONE } from '@/utils/constant'

const user = {
  state: {
    token: getLocalStorage(USER_TOKEN),
    userinfo: getLocalStorage(USER_INFO),
    userPhone: getLocalStorage(USER_PHONE),
    editAddress: getLocalStorage(EDIT_ADDRESS, 'true'),
    userBalance: getLocalStorage(USER_BALANCE_INFO, 'true') || {},
    onLineBalance: getLocalStorage(USER_ONLINE_BALANCE_INFO, 'true') || {},
  },
  mutations: {
    SET_TOKEN: (state, token) => { 
      state.token = token
      if (token) {
        setLocalStorage(USER_TOKEN, token)
      }
    },
    SET_PHONE: (state, userPhone) => { 
      state.userPhone = userPhone
      if (userPhone) {
        setLocalStorage(USER_PHONE, userPhone)
      }
    },
    SET_EDIT_ADDRESS: (state, data) => {
      state.editAddress = data
      setLocalStorage(EDIT_ADDRESS, data)
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      setLocalStorage(USER_INFO, userInfo)
    },
    SET_USER_BALANCE: (state, data) => {
      if (data) {
        var rep = state.userBalance;
        rep = { ...rep, ...data }
        state.userBalance = rep
        setLocalStorage(USER_BALANCE_INFO, rep)
      } else {
        state.userBalance = {}
      }
    },
    SET_USER_ONLINE_BALANCE: (state, data) => {
      if (data) {
        var rep = state.onLineBalance;
        rep = { ...rep, ...data }
        state.onLineBalance = rep
        setLocalStorage(USER_ONLINE_BALANCE_INFO, rep)
      } else {
        state.onLineBalance = {}
      }
    },
  },
  actions: {
    // 用户登录
    LoginByUser ({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_TOKEN', data)
        resolve()
      }).catch(error => {
        return Promise.reject(error)
      })
    },
     // 签约用户手机号
     LoginByUserPhone({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_PHONE', data)
        resolve()
      }).catch(error => {
        return Promise.reject(error)
      })
    },
    // 清除结算信息
    BalanceOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_USER_BALANCE', null)
        removeLocalStorage(USER_BALANCE_INFO)
        resolve()
      }).catch(error => {
        return Promise.reject(error)
      })
    },
    // 清除结算信息
    OnlineBalanceOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_USER_ONLINE_BALANCE', null)
        removeLocalStorage(USER_ONLINE_BALANCE_INFO)
        resolve()
      }).catch(error => {
        return Promise.reject(error)
      })
    },
    // 登出
    LogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', null)
        removeLocalStorage(USER_TOKEN)
        removeLocalStorage(USER_INFO)
        removeLocalStorage(USER_BALANCE_INFO)
        resolve()
      }).catch(error => {
        return Promise.reject(error)
      })
    }

  }
}
export default user
